import { Helmet } from "react-helmet-async";

interface LocalBusinessJsonLdProps {
  name: string;
  description: string;
  phone: string;
  email: string;
  address: string;
  url?: string;
}

export function LocalBusinessJsonLd({
  name,
  description,
  phone,
  email,
  address,
  url = "https://morganlandcompany.lovable.app",
}: LocalBusinessJsonLdProps) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "RealEstateAgent",
    name,
    description,
    telephone: phone,
    email,
    address: {
      "@type": "PostalAddress",
      streetAddress: address,
    },
    url,
    sameAs: [],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
}
